/**************************************************
 * Nombre:       Tarjeta_Evento_Calendario
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {formatoFechaDays} from "../../Utilidades/formatoFechaDays";
import {irUrl} from "../../Utilidades/irUrl";
import {GRADIENTE} from "../../Constantes";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {formatoHora} from "../../Utilidades/formatoHora";
import preder from '../../Recursos/predeterminada.svg'

const Tarjeta_Evento_Calendario = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={4} sx={{justifyContent: 'flex-start'}}>
                <img src={item.img ? item.img : preder} width={'90%'} height={'auto'} style={{borderRadius: 4}}/>
            </Grid>

            <Grid container size={8} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{color: theme.palette.primary.main, fontSize: 16, fontWeight: 500}}>
                            {`${formatoFechaDays(item.fecha)} ${item.hora ? ' Hora ' + formatoHora(item.hora) : ''}`}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                        <Typography
                            sx={{fontSize: !masSM ? 20 : 28, fontWeight: 700, lineHeight: 1.1}}>
                            {item.nombre}
                        </Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography
                            sx={{
                                fontSize: !masSM ? 14 : 16,
                                fontWeight: 300,
                                fontFamily: 'Inter',
                                lineHeight: 1.2,
                                textOverflow: "ellipsis",
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: !masSM ? 5 : 6
                            }}>
                            {item.descripcion}

                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                          sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Button
                            onClick={() => irUrl(item.link)}
                            sx={{background: GRADIENTE, px: 4}}>{item.nombreBoton}</Button>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Evento_Calendario